import _cloneDeep from 'lodash/cloneDeep';
import {DEFAULT_CONDITION} from '../compoundConditions.consts';

export default function getEmptyCondition() {
  return _cloneDeep(DEFAULT_CONDITION);
}
